import { render, staticRenderFns } from "./ReviewScore.vue?vue&type=template&id=b7c514d4&scoped=true&"
import script from "./ReviewScore.vue?vue&type=script&lang=js&"
export * from "./ReviewScore.vue?vue&type=script&lang=js&"
import style0 from "./ReviewScore.vue?vue&type=style&index=0&id=b7c514d4&scoped=true&lang=css&"
import style1 from "./ReviewScore.vue?vue&type=style&index=1&id=b7c514d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c514d4",
  null
  
)

export default component.exports